import { format } from 'date-fns'

import { useMoney } from '@/composables/useMoney'

export function formatDate(date: string | number | Date | undefined): string {
  return format(new Date(date ?? Date.now()), 'dd/MM/yyyy HH:mm')
}

export function formatDateWithoutTime(date: string | number | Date | undefined): string {
  return format(new Date(date ?? Date.now()), 'dd/MM/yyyy')
}

export function formatCurrency(value: number): string {
  const { currency } = useMoney()
  return currency(value)
}
